module.exports = __webpack_public_path__ + "static/media/activity-send-file.6c1c64c7.svg";